import React, { FC } from 'react';
import ResourceLibraryCreate from '../../../../sales-kit/components/Library/pages/Create';
import { HAPPY_SHARE_MATERIAL_BASE_PATH, HAPPY_SHARE_LIBRARY_BASE_PATH } from '../../../constants';
import { SALESKIT_BASE_PATH } from 'src/app/modules/sales-kit/constants';

export const SystemConfig = {
  blockName: 'component.formTitle.happy-share-material',
  blockType: 'happyShareMaterial',
  //PHKL Custom
  libraryBasePath: `${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}`,
  categoryType: 'happyShareMaterialCategory',
  columnType: 'happyShareMaterialColumn',
  addSuccessText: 'global.submit.success',
  columnModuleType: 'happyShareMaterial',
  moduleType: 'HappyShare',
};

const HappyShareLibraryCreatePage: FC<any> = (props) => {
  return <ResourceLibraryCreate {...props} {...SystemConfig} />;
};

export default HappyShareLibraryCreatePage;
